import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React from 'react';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Impressum from './pages/Impressum';
import AGBs from './pages/AGBs';
import Datenschutz from './pages/Datenschutz';
import { CookieConsentProvider } from './contexts/CookieConsentContext';
import { ContentProtectionProvider } from './contexts/ContentProtectionContext';
import CookieBanner from './components/CookieConsent/CookieBanner';

// ScrollToTop component to handle scroll behavior
const ScrollToTop = () => {
  const location = useLocation();
  const { pathname, search } = location;

  React.useEffect(() => {
    // Only scroll to top if there's no search parameter
    if (!search) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Use instant instead of smooth for better UX
      });
    }
  }, [pathname, search]); // Include both pathname and search in dependencies

  return null;
};
// Wrapper component to handle layout logic
const AppLayout = () => {
  const location = useLocation();
  const is404Page = location.pathname !== '/' && 
                    location.pathname !== '/services' && 
                    location.pathname !== '/about' && 
                    location.pathname !== '/contact' &&
                    location.pathname !== '/impressum' &&
                    location.pathname !== '/agb' &&
                    location.pathname !== '/datenschutz' &&
                    !location.pathname.includes('403_Akkreditierungsbestatigung_I_2023.pdf') &&
                    !location.pathname.includes('2023-0803.603_Akkreditierungsumfang_Bescheid.pdf');

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/agb" element={<AGBs />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!is404Page && <Footer />}
      <CookieBanner />
    </div>
  );
};

function App() {
  return (
    <CookieConsentProvider>
      <ContentProtectionProvider>
        <Router>
          <ScrollToTop />
          <AppLayout />
        </Router>
      </ContentProtectionProvider>
    </CookieConsentProvider>
  );
}

export default App;